module.exports = __webpack_public_path__ + "ca21772ccd0f0d39dcdd79904a6005e7.svg";